import React, { useRef } from "react";
import { MDBTypography, MDBBox, MDBContainer } from "mdbreact";
import Slider from "react-slick";
import { Link } from "react-router-dom";
import useSlickTabOrder from "../useSlickTabOrder";

const CategorySectionV2 = ({ categorySectionData }) => {
  const sliderRef = useRef(null);

  useSlickTabOrder(sliderRef, categorySectionData);

  const sliderSettings = {
    dots: false,
    arrows: true,
    infinite: true,
    // autoplay: sliderData.autoplay,
    // autoplaySpeed: 7000,
    // speed: 2800,
    // cssEase: "linear",
    slidesToShow: 5,
    variableWidth: false,
    draggable: true,
    slidesToScroll: 1,
    lazyLoad: "ondemand",
    easing: "linear",
    pauseOnHover: false,
    responsive: [
      {
        breakpoint: 1025,
        settings: {
          infinite: true,
          autoplay: false,
          slidesToShow: 4,
          slidesToScroll: 1,
          initialSlide: 1,
          dots: false,
          swipe: true,
        },
      },
      {
        breakpoint: 834,
        settings: {
          infinite: true,
          autoplay: false,
          slidesToShow: 3,
          slidesToScroll: 1,
          initialSlide: 1,
          dots: false,
          swipe: true,
        },
      },
      {
        breakpoint: 430,
        settings: {
          infinite: false,
          autoplay: false,
          slidesToShow: 1.5,
          slidesToScroll: 1,
          initialSlide: 1,
          dots: false,
          swipe: true,
        },
      },
    ],
  };

  return (
    <MDBContainer fluid className="explore-container">
      <MDBTypography className="explore-title" tag="h1" variant="h1">
        Explore by Category
      </MDBTypography>
      <div className="slider-wrapper">
        <Slider
          {...sliderSettings}
          ref={sliderRef}
          className="category-slider"
        >
          {categorySectionData?.map(
            (data) =>
              data.image && (
                <Link
                  fluid
                  to={data.url}
                  className="card-link"
                  rel="noreferrer noopener"
                >
                  <MDBBox className="explore-card">
                    <MDBBox className="image-wrapper">
                      <img
                        src={data.image}
                        alt=""
                        className="slide-image img-fluid"
                      />
                    </MDBBox>
                    <MDBTypography
                      className="explore-cards-title"
                      tag="h2"
                      variant="h6"
                    >
                      {data.title}
                    </MDBTypography>
                  </MDBBox>
                </Link>
              )
          )}
        </Slider>
      </div>
    </MDBContainer>
  );
};

export default CategorySectionV2;
